import { render } from "./CreateEvent.vue?vue&type=template&id=08222b14&scoped=true"
import script from "./CreateEvent.vue?vue&type=script&lang=js"
export * from "./CreateEvent.vue?vue&type=script&lang=js"

import "../../../assets/css/inner.css?vue&type=style&index=0&id=08222b14&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TATS\\Documents\\Projects\\PHP-Laravel\\TatSingWeb\\tsg-exec\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08222b14"]])

export default __exports__